/*
 * qi-w2-cta.js — QI LITE W2 config-summary mirror (checkout-ready PDPs only)
 * --------------------------------------------------------------------------
 * PRESENTATIONAL ONLY. Reads existing configurator inputs and mirrors state
 * into the W2 summary spans. Does NOT touch the cart, the form, CartJS, or any
 * W1 / setTierPricingImprint id. All targets are qi-w2- prefixed; every lookup
 * is null-guarded so non-curated pages (where the block is absent) no-op.
 *
 * Writes: #qi-w2-method (imprint method label), #qi-w2-colors (logo colors),
 *         #qi-w2-price-mirror (mirror of W1 #price). MOQ is static Liquid.
 * The primary buy button delegates to the existing #addToCart via .click()
 * (wired inline in product.liquid) — no purchase logic lives here.
 */
(function () {
  'use strict';

  function el(id) { return document.getElementById(id); }

  function sync() {
    var sel = el('imprintSelect');
    var method = el('qi-w2-method');
    var colors = el('qi-w2-colors');
    var colorInput = el('imprintColorId');
    var price = el('price');
    var mirror = el('qi-w2-price-mirror');

    if (method) {
      // 'Blank' matches the select's own placeholder wording for "no imprint"
      var txt = 'Blank';
      if (sel && sel.value && sel.selectedIndex >= 0) {
        txt = (sel.options[sel.selectedIndex].textContent || '').trim() || 'Blank';
      }
      method.textContent = txt;
    }
    if (colors) {
      colors.textContent = (sel && sel.value && colorInput) ? (colorInput.value || '1') : '—';
    }
    if (mirror && price) {
      mirror.textContent = price.textContent || '—';
    }
  }

  function bind() {
    ['imprintSelect', 'imprintColorId', 'quantity'].forEach(function (id) {
      var e = el(id);
      if (e) { e.addEventListener('change', sync); e.addEventListener('input', sync); }
    });
    sync();
    // qi-live-price.js fills #price on its own pass and announces it — mirror on
    // the event rather than racing it with a timeout.
    document.addEventListener('qi:price', sync);
    setTimeout(sync, 300); // belt-and-braces for browsers without CustomEvent
  }

  window.QIW2Cta = { sync: sync };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
